module.exports = __webpack_public_path__ + "img/af9657f.jpg";